import Button from '@mui/material/Button'
import { Fragment } from 'react'

type Props = {
  isSubmitDisabled: boolean
  backHandler: () => void
  submitHandler: () => void
}

export default function ContactsUploadConfigureActions({ backHandler, submitHandler, isSubmitDisabled }: Props) {
  return (
    <Fragment>
      <Button variant="outlined" onClick={backHandler}>
        Back
      </Button>
      <Button
        id="contacts-upload-confirm-button"
        variant="contained"
        color="primary"
        disabled={isSubmitDisabled}
        onClick={submitHandler}
      >
        Next
      </Button>
    </Fragment>
  )
}
